import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import { useForgotPasswordMutation } from '../slices/usersApiSlice';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const res = await forgotPassword({ email }).unwrap();
      toast.success(res.message);
      setEmail('');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <div className="section-modern">
      <div className="container-modern">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="form-modern fade-in">
              <div className="text-center mb-4">
                <h1 className="text-primary mb-2">Forgot Password</h1>
                <p className="text-secondary">
                  Enter your email and we&apos;ll send you a reset link.
                </p>
              </div>

              <Form onSubmit={submitHandler}>
                <div className="form-group-modern">
                  <label htmlFor="email" className="form-label-modern">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-input-modern"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary-modern w-100 mb-3"
                >
                  {isLoading ? 'Sending Reset Link...' : 'Send Reset Link'}
                </button>
              </Form>

              {isLoading && (
                <div className="text-center py-3">
                  <Loader />
                </div>
              )}

              <div
                className="text-center mt-4 pt-4"
                style={{ borderTop: '1px solid var(--border-light)' }}
              >
                <p className="text-secondary mb-0">
                  Remembered it?{' '}
                  <Link to="/login" className="text-decoration-none fw-medium">
                    Back to sign in
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
